<template>
  <div class="bar_chart_container">
    <div ref="barChart" class="bar_chart" />

    <div class="bg_card">
      <span><span class="bg_blue color_card" /> {{ $t('collectionCenter.inboundTickets') }}</span><!-- 入库票数 -->
      <span><span class="bg_green color_card" /> {{ $t('collectionCenter.outboundTickets') }}</span><!-- 出库票数 -->
      <span><span class="bg_Pumpkin color_card" /> {{ $t('collectionCenter.inventoryTickets') }}</span><!-- 库存票数 -->
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  name: 'BarChart',
  props: {
    // 可以通过props接收外部数据
    chartData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      // 近7日入库/出库趋势数据
      trendChartData: {
        statDate: [],
        inboundTicketCount: [],
        outboundTicketCount: [],
        currentTicketCount: []
      },
      barChart: null
    };
  },
  watch: {
    chartData: {
      handler(newVal) {
        this.trendChartData = newVal;
        this.initBarChart();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    initBarChart() {
      this.$nextTick(() => {
        if (!this.$refs.barChart) return;

        // 初始化图表实例
        this.barChart = echarts.init(this.$refs.barChart);

        // 配置项
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#999'
              }
            },
            formatter: function(params) {
              let result = params[0].name + '<br/>';
              params.forEach(param => {
                result += param.marker + param.seriesName + ': ' +
                  param.value.toLocaleString() + '<br/>';
              });
              return result;
            }
          },
          legend: {
            show: false
            // data: ['入库票数', '出库票数', '库存票数'],
            // bottom: 0,
            // left: 'left',
            // icon: 'roundRect',
            // itemWidth: 12,
            // itemHeight: 12
          },
          grid: {
            left: '1%',
            right: '1%',
            bottom: '5%',
            top: '1%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: this.trendChartData.statDate,
              axisPointer: {
                type: 'shadow'
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false // 隐藏刻度线
              },
              axisLabel: {
                color: '#667085'
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              name: '',
              min: 0,
              max: function(value) {
                return Math.ceil(value.max * 1.1); // 设置最大值略高于实际最大值
              },
              interval: function(value) {
                return Math.ceil(value.max / 5); // 自动计算间隔
              },
              axisTick: {
                show: false // 隐藏刻度线
              },
              axisLabel: {
                show: false
              },
              splitLine: {
                show: false // 保留网格线
              }
            }
          ],
          series: [
            {
              name: this.$t('collectionCenter.inboundTickets'),
              type: 'bar',
              data: this.trendChartData.inboundTicketCount,
              itemStyle: {
                barBorderRadius: [15, 15, 0, 0],
                color: '#2563eb' // 蓝色
              },
              barWidth: 12
            },
            {
              name: this.$t('collectionCenter.outboundTickets'),
              type: 'bar',
              data: this.trendChartData.outboundTicketCount,
              itemStyle: {
                barBorderRadius: [15, 15, 0, 0],
                color: '#16a34a' // 绿色
              },
              barWidth: 12
            },
            {
              name: this.$t('collectionCenter.inventoryTickets'),
              type: 'bar',
              data: this.trendChartData.currentTicketCount,
              itemStyle: {
                barBorderRadius: [15, 15, 0, 0],
                color: '#ea580c' // 橙色
              },
              barWidth: 12
            }
          ]
        };

        // 设置配置项
        this.barChart.setOption(option);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.bar_chart_container {
  margin-top: 10px;
  width: 100%;
}
.bar_chart {
  width: 100%;
  height: 400px;
  border-radius: 15px;
  border: 1px solid #eef2f6;
  box-sizing: border-box;
  overflow-x: auto;
  overflow-y: hidden;
}
.bg_card { margin-top: 10px;display: flex;align-items: center;gap: 15px;font-size: 13px;color: #667085; }
.bg_green,.bg_blue,.bg_Pumpkin { height: 100%;display: inline-block; }
.bg_green { background: #16a34a; }
.bg_blue { background: #2563eb; }
.bg_Pumpkin { background: #ea580c; }
.color_card { border-radius: 3px;box-sizing: border-box;display: inline-block; width: 11px; height: 11px; }
</style>
